<div class="toast-main">
  <div class="toast-bg-icon">
    <div class="toast-icon"></div>
  </div>

  <div class="toast-content">
    <!-- Title -->
    @if (title()) {
      <div [class]="options().titleClass" [attr.aria-label]="title()">
        {{ title() }}

        @if (duplicatesCount()) {
          [{{ duplicatesCount() + 1 }}]
        }
      </div>
    }

    <!-- Message -->
    @if (message()) {
      <!-- Alert content -->
      @if (options().enableHtml) {
        <div
          role="alert"
          [class]="options().messageClass"
          [innerHTML]="message()"
          [attr.data-qa-id]="'toast_message'"></div>
      } @else {
        <div
          role="alert"
          [class]="options().messageClass"
          [attr.aria-label]="message()"
          [attr.data-qa-id]="'toast_message'">
          {{ message() }}
        </div>
      }

      <!-- Alert content -->
    }
  </div>
</div>

@if (options().closeButton) {
  <button type="button" class="toast-close-button" aria-label="Close" (click)="remove()">
    <span aria-hidden="true">&times;</span>
  </button>
}
